<template>
  <div>
    <es-title title="Processamento de Repasses Empresas">
      <div slot="left">
        <div v-if="tab == 1" class="button" @click="tab = 0, get()">Voltar</div>
      </div>
      <div slot="right">
        <div v-if="tab == 0">
          <div class="button is-danger" @click="toggleModalImportacao()">Importação de planilhas</div>
        </div>
      </div>
    </es-title>

    <es-modal title="Importação de Arquivos" :config="modalImportacao">
      <div class="field">
        <div class="file is-centered is-boxed is-success has-name">
          <label class="file-label">
            <input class="file-input" type="file" @change="importacaoMovimento" accept=".xlsx, .xls">
            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-upload"></i>
              </span>
              <span class="file-label">
                Selecionar arquivo Movimento (Empresas)
              </span>
            </span>
          </label>
        </div>
      </div>
      <div class="field">
        <div class="file is-centered is-boxed is-success has-name">
          <label class="file-label">
            <input class="file-input" type="file" @change="importacaoCooperativas" accept=".xlsx, .xls">
            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-upload"></i>
              </span>
              <span class="file-label">
                Selecionar arquivo Cooperativas
              </span>
            </span>
          </label>
        </div>
      </div>

      <div class="field">
        <div class="file is-centered is-boxed is-success has-name">
          <label class="file-label">
            <input class="file-input" type="file" @change="importacaoEmpresasCadastroDatas" accept=".xlsx, .xls">
            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-upload"></i>
              </span>
              <span class="file-label">
                Selecionar arq. Empresas Cadastro-Datas
              </span>
            </span>
          </label>
        </div>
      </div>
      <div class="field">
        <button class="button is-success" :disabled="!isEnviarAtivo" @click="enviarArquivos">Enviar</button>
      </div>
    </es-modal>

    <hr style="margin: 40px 0; border-top: 2px solid #ccc;" />

    <es-title title="Gerar comprovante">
      <template #right>
        <div class="button is-danger" @click="toggleModalComprovante">Gerar Comprovante</div>
      </template>
    </es-title>

    <es-modal title="Gerar comprovante" :config="modalComprovante">
      <div class="field">
        <div class="file is-centered is-boxed is-sucess has-name">
          <label class="file-label">
            <input class="file-input" type="file" @change="importacaoComprovante" accept=".xlsx, .xls">
            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-upload"></i>
              </span>
              <span class="file-label">
                Selecionar arquivo para comprovante
              </span>
            </span>
          </label>
        </div>
      </div>

      <div class="field">
        <button class="button is-success" :disabled="!comprovanteArquivo" @click="enviarComprovante">Enviar</button>
      </div>
    </es-modal>
        
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      tab: 0,
      arquivos: {
        movimento: null,
        cooperativas: null,
        empresas_cadastro_datas: null,
      },
      isEnviarAtivo: false,  
      modalImportacao: {
        active: false
      },
      comprovanteArquivo: null,
      modalComprovante: {
        active: false
      },
      loading: false, 
    };
  },
  methods: {
    toggleModalImportacao() {
      this.modalImportacao.active = !this.modalImportacao.active;
    },

    importacaoMovimento(event) {
      const file = event.target.files[0];
      if (file && this.validarArquivo(file)) {
        this.arquivos.movimento = file;
      } else {
        this.arquivos.movimento = null;
      }
      this.validarEnvio();
    },

    importacaoCooperativas(event) {
      const file = event.target.files[0];
      if (file && this.validarArquivo(file)) {
        this.arquivos.cooperativas = file;
      } else {
        this.arquivos.cooperativas = null;
      }
      this.validarEnvio();
    },

    importacaoEmpresasCadastroDatas(event) {
      const file = event.target.files[0];
      if (file && this.validarArquivo(file)) {
        console.log(file)
        this.arquivos.empresas_cadastro_datas = file;
      } else {
        this.arquivos.empresas_cadastro_datas = null;
      }
      this.validarEnvio();
    },

    validarArquivo(file) {
      const allowedExtensions = ['.xlsx', '.xls'];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      return allowedExtensions.includes(`.${fileExtension}`);
    },

    validarEnvio() {
      this.isEnviarAtivo =
        this.arquivos.movimento && this.arquivos.cooperativas && this.arquivos.empresas_cadastro_datas;
    },
    
    enviarArquivos() {
      const formData = new FormData();
      formData.append('movimento', this.arquivos.movimento);
      formData.append('cooperativas', this.arquivos.cooperativas);
      formData.append('empresas_cadastro_datas', this.arquivos.empresas_cadastro_datas);

      console.log(this.arquivos.empresas_cadastro_datas);

      axios.post('api/v1/batimento/processar_movimentos/importacao', formData, { responseType: 'blob' })
        .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'VALORES_EXTRAS_ESTADUAIS.xlsx');  
        document.body.appendChild(link);
        link.click();
        
        document.body.removeChild(link);
        
        this.toggleModalImportacao(); 
      })
      .catch(error => {
        console.error("Erro ao enviar os arquivos:", error);
      });
    },
    toggleModalComprovante() {
      this.modalComprovante.active = !this.modalComprovante.active;
    },

    importacaoComprovante(event) {
      const file = event.target.files[0];
      if (file && this.validarArquivo(file)) {
        this.comprovanteArquivo = file;
      } else {
        this.comprovanteArquivo = null;
      }
    },

    enviarComprovante() {
      const formData = new FormData();
      formData.append('comprovante', this.comprovanteArquivo);

      axios.post('api/v1/batimento/gerar_comprovante/gerar', formData, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'comprovantes_gerados.zip');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.toggleModalComprovante();
        })
        .catch(error => {
          console.error("Erro ao gerar comprovantes:", error);
        });
    },
    showLoading() {
      this.loading = true;
    },

    closeLoading() {
      this.loading = false;
    },

  }
};
</script>
<style lang="scss">
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100vh;
  text-align: center;
}

.table-container {
  width: 80%;
  margin-top: 30px;
  text-align: center;
}

.button.is-success {
  background-color: #23d160;
  border-color: #23d160;
}

.file-cta {
  background-color: #23d160;
  color: white;
}

.file-name {
  margin-left: 10px;
}

.modal-background {
  background-color: rgba(10, 10, 10, 0.21) !important;
}

.area-main {
  display: block !important;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.q-spinner {
  font-size: 40px;
  color: #23d160;
}

.file {
  width: 100%;
  max-width: 400px; 
  margin: 0 auto; 
}

.file-label {
  width: 100%;  
}

.file-input {
  width: 100%; 
}

.file-cta {
  width: 100%; 
}

.file-name {
  width: 100%;
  text-align: left;
}

.button.is-success {
  margin-top: 20px;
}

@media screen and (max-width: 768px) {
  .file {
    max-width: 90%;
  }
}
</style>
